import { Component, input, output } from "@angular/core";
import { CustomSonnerToasterUifComponent } from "../custom-sonner-toaster-uif/custom-sonner-toaster-uif.component";
import { NgTemplateOutlet } from "@angular/common";

@Component({
  selector: "app-form-blocker-uif",
  imports: [CustomSonnerToasterUifComponent, NgTemplateOutlet],
  templateUrl: "./form-blocker-uif.component.html",
  styles: ``,
})
export class FormBlockerUifComponent {
  //#region I/O
  type = input.required<"success" | "warning" | "error" | "info">();
  messageTitle = input.required<string>();
  description = input.required<string>();
  onDisabled = input.required<boolean>();
  blocKInput = input<boolean>(true);
  useAlert = input.required<boolean>();
  clicked = output<void>();
  //#endregion
}
